import { OrderItemV2 } from "@/models/orders/OrderDraft";

export const useOrderItemSummary = (orderItem: OrderItemV2) => {
  const { price, displayPrice, discount, qty } = orderItem;

  return {
    displayDiscountAmount: displayPrice - price + discount,
    displayOriginalPrice: displayPrice,
    displaySalePrice: price - discount,
    qty,
  };
};
